import { NgxMaskModule } from 'ngx-mask';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { NgModule, Injector } from '@angular/core';
import { MaterialModule } from '@angular/material';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from '../app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { HttpClientModule, HttpClient as HttpClient2 } from '@angular/common/http';
import { AccordionModule } from 'ngx-accordion';
import { TextMaskModule } from 'angular2-text-mask';

import { HomeComponent } from './home/home.component';
import { DeniedComponent } from './denied/denied.component';
import { LoadingComponent } from '../shared/component/loading.component';
import { DialogResultComponent } from '../shared/component/dialog-result.component';

import { LoginComponent } from './login/login.component';
import { ClipboardModule } from 'ngx-clipboard';
import { DevedorEditComponent } from './devedor/edit/devedor.edit.component';
import { TelefoneEditComponent } from './telefone/edit/telefone.edit.component';
import { EnderecoEditComponent } from './endereco/edit/endereco.edit.component';
import { EmailEditComponent } from './email/edit/email.edit.component';
import { ConfirmEditComponent } from './confirm/edit/confirm.edit.component';
import { BoletoEmailEditComponent } from './boletoemail/edit/boletoemail.edit.component';
import { PagamentoEditComponent } from './pagamento/edit/pagamento.edit.component';
import { PortalComponent } from './portal/portal.component';
import { PrincipalComponent } from './wizard/principal.component';
import { WizardStepComponent } from './wizard/wizard-step.component';
import { WizardComponent } from './wizard/wizard.component';
import { ContratoComponent } from './contrato/contrato.component';
import { ContratoAgregadoComponent } from './contrato/contrato.agregado.component';
import { DividasumarizadoComponent } from './dividasumarizado/dividasumarizado.component';
import { OuvirLigacaoComponent } from './audio/ouvirligacao.component';
import { ConfirmWizardEditComponent } from './confirm/edit/confirmWizard.edit.component';

import {
    BaseController,
    PesquisaBaseController,
    DetalheBaseController
} from '../helpers/index';

import {
    DialogService,
    LoadingService,
    createTranslateLoader
} from '../services';
import { MediaplayerComponent } from './mediaplayer/mediaplayer.component';
import { ApresentacaoComponent } from './apresentacao/apresentacao.component';
import { CartaQuitacaoComponent } from './carta-quitacao/carta-quitacao.component';




@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        BrowserModule,
        FormsModule,
        ClipboardModule,
        HttpModule,
        NgxPaginationModule,
        AppRoutingModule,
        SharedModule,
        DataTableModule,
        AccordionModule,
        TextMaskModule,
        NgxMaskModule.forRoot(),
        SimpleNotificationsModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient2]
            }
        })
    ],
    declarations: [
        DeniedComponent
        , LoadingComponent
        , DialogResultComponent
        , LoginComponent
        , HomeComponent
        , DevedorEditComponent
        , TelefoneEditComponent
        , EnderecoEditComponent
        , EmailEditComponent
        , ConfirmEditComponent
        , BoletoEmailEditComponent
        , PortalComponent
        , PagamentoEditComponent
        , PrincipalComponent
        , WizardComponent
        , WizardStepComponent
        , ContratoComponent
        , ContratoAgregadoComponent
        , DividasumarizadoComponent
        , MediaplayerComponent
        , ApresentacaoComponent
        , OuvirLigacaoComponent
        , ConfirmWizardEditComponent, CartaQuitacaoComponent
    ],
    exports: [
        DeniedComponent
        , LoadingComponent
        , DialogResultComponent
        , LoginComponent
        , HomeComponent
        , DevedorEditComponent
        , PortalComponent
        , ContratoComponent
        , ContratoAgregadoComponent
    ],
    entryComponents: [
        DialogResultComponent
        , LoadingComponent
        , WizardComponent
        , WizardStepComponent
        , ContratoComponent
        , ContratoAgregadoComponent
    ],
    providers: [
        BaseController
        , PesquisaBaseController
        , DetalheBaseController
        , DialogService
        , LoadingService
        , DatePipe
        , CurrencyPipe
    ]
})
export class ComponentsModule {
    static injector: Injector;

    constructor(injector: Injector) {
        ComponentsModule.injector = injector;
    }
}




// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/components.module.ts